import * as React from "react";

const HRChart = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170 28" {...props}>
      <rect width="15" height="2.5" y="13.457" fill="#852170" rx="1.25"></rect>
      <rect
        width="13.719"
        height="2.5"
        x="40.055"
        y="13.457"
        fill="#852170"
        rx="1.25"
      ></rect>
      <rect
        width="30"
        height="2.5"
        x="18.313"
        y="25.994"
        fill="#852170"
        rx="1.25"
        transform="rotate(-60 18.313 25.994)"
      ></rect>
      <rect
        width="15"
        height="2.5"
        x="14.234"
        y="13.012"
        fill="#852170"
        rx="1.25"
        transform="rotate(60 14.234 13.012)"
      ></rect>
      <rect
        width="17.496"
        height="2.5"
        x="34.227"
        fill="#852170"
        rx="1.25"
        transform="rotate(60 34.227 0)"
      ></rect>
      <rect
        width="13.719"
        height="2.5"
        x="78.789"
        y="13.479"
        fill="#852170"
        rx="1.25"
      ></rect>
      <rect
        width="30"
        height="2.5"
        x="57.047"
        y="26.016"
        fill="#852170"
        rx="1.25"
        transform="rotate(-60 57.047 26.016)"
      ></rect>
      <rect
        width="15"
        height="2.5"
        x="52.969"
        y="13.033"
        fill="#852170"
        rx="1.25"
        transform="rotate(60 52.969 13.033)"
      ></rect>
      <rect
        width="17.496"
        height="2.5"
        x="72.961"
        y="0.021"
        fill="#852170"
        rx="1.25"
        transform="rotate(60 72.96 .021)"
      ></rect>
      <rect
        width="13.719"
        height="2.5"
        x="117.539"
        y="13.484"
        fill="#852170"
        rx="1.25"
      ></rect>
      <rect
        width="30"
        height="2.5"
        x="95.797"
        y="26.021"
        fill="#852170"
        rx="1.25"
        transform="rotate(-60 95.797 26.021)"
      ></rect>
      <rect
        width="15"
        height="2.5"
        x="91.719"
        y="13.039"
        fill="#852170"
        rx="1.25"
        transform="rotate(60 91.719 13.04)"
      ></rect>
      <rect
        width="17.496"
        height="2.5"
        x="111.711"
        y="0.027"
        fill="#852170"
        rx="1.25"
        transform="rotate(60 111.711 .027)"
      ></rect>
      <rect
        width="13.719"
        height="2.5"
        x="156.266"
        y="13.467"
        fill="#852170"
        rx="1.25"
      ></rect>
      <rect
        width="30"
        height="2.5"
        x="134.523"
        y="26.004"
        fill="#852170"
        rx="1.25"
        transform="rotate(-60 134.523 26.004)"
      ></rect>
      <rect
        width="15"
        height="2.5"
        x="130.445"
        y="13.021"
        fill="#852170"
        rx="1.25"
        transform="rotate(60 130.445 13.021)"
      ></rect>
      <rect
        width="17.496"
        height="2.5"
        x="150.438"
        y="0.01"
        fill="#852170"
        rx="1.25"
        transform="rotate(60 150.438 .01)"
      ></rect>
    </svg>
  );
};

export default HRChart;
